import { z } from 'zod'

export const loginFormSchema = z.object({
  email: z
    .string()
    .trim()
    .min(1, 'Email is required')
    .regex(/^[^\s@]+@[^\s@]+\.[^\s@]+$/, 'Please enter a valid email address')
    .transform(val => val.toLowerCase()),
  password: z.string().trim().min(1, 'Password is required').min(6, 'Password must be at least 6 characters')
})

export type LoginFormValues = z.infer<typeof loginFormSchema>

export const defaultLoginFormValues: LoginFormValues = {
  email: '',
  password: ''
}
